import { NotificationRegistryRead } from "@/services/generatedApi";
import { FinishedIcon } from "@/ui-components/Icons";
import { SafeHTML } from "@/ui-components/SanitizeHTML";
import { Box, Typography } from "@mui/material";
import * as React from "react";
import { useNavigate } from "react-router-dom";

interface NotificationBodyProps {
  notification: NotificationRegistryRead;
  markAsRead: (arg0: number) => void;
  link?: string;
}

export const NotificationBody: React.FC<NotificationBodyProps> = ({ link, notification, markAsRead }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        borderBottom: "1px solid var(--grey-color-300)",
        "&:hover": {
          backgroundColor: "var(--grey-color-100)",
          cursor: "pointer",
        },
        padding: "16px 24px 16px 16px",
      }}
    >
      <Box
        sx={{
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
        onClick={() => {
          markAsRead(notification.id);
          if (link) {
            navigate(link);
          }
        }}
        role="button"
      >
        <Box>
          <SafeHTML html={notification.notification_body.message} />
        </Box>
        {!notification.dismissed_at && (
          <Box>
            <FinishedIcon />
          </Box>
        )}
      </Box>
      {notification.notification_body.location.assessment_name && (
        <Box>
          <Typography
            sx={{
              fontSize: "12px",
              color: "var(--soft-black-gray-scale-600)",
            }}
          >
            {notification.notification_body.location.assessment_name}
            ,&nbsp;
            {notification.notification_body.location.site_name}
            ,&nbsp;
            {notification.notification_body.location.protocol_question_name}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
